/**
 * @generated SignedSource<<1ec1ac1fa33d921508db3ba2e751beaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScreenersCharacteristicTypeChoices = "DT" | "GS" | "MS" | "NM" | "OE" | "SS" | "%future added value";
export type PanelistsReportWrapperQuery$variables = {};
export type PanelistsReportWrapperQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly profile: {
        readonly tenant: {
          readonly characteristics: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly answers: ReadonlyArray<{
                  readonly id: string;
                  readonly text: string;
                }>;
                readonly id: string;
                readonly importKey: string;
                readonly text: string | null;
                readonly type: ScreenersCharacteristicTypeChoices;
              } | null;
            } | null>;
          };
          readonly " $fragmentSpreads": FragmentRefs<"PanelistsReport_tenant">;
        };
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PanelistsReport_viewer">;
  };
};
export type PanelistsReportWrapperQuery = {
  response: PanelistsReportWrapperQuery$data;
  variables: PanelistsReportWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importKey",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = [
  (v0/*: any*/),
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "CharacteristicAnswerNode",
  "kind": "LinkedField",
  "name": "answers",
  "plural": true,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipantNode",
  "kind": "LinkedField",
  "name": "latestRatedParticipant",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rating",
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsBalance",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "joined",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "other",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userSpecified",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAnswer",
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CharacteristicNode",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortName",
        "storageKey": null
      },
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "CharacteristicRowNode",
        "kind": "LinkedField",
        "name": "rows",
        "plural": true,
        "selections": (v4/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v20 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PanelistsReportWrapperQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PanelistsReport_viewer"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TenantNode",
                    "kind": "LinkedField",
                    "name": "tenant",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicNodeConnection",
                        "kind": "LinkedField",
                        "name": "characteristics",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CharacteristicNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PanelistsReport_tenant"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PanelistsReportWrapperQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PanelistNode",
            "kind": "LinkedField",
            "name": "panelist",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PanelistMembershipNode",
                "kind": "LinkedField",
                "name": "panelistMembership",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonNode",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "avatarUrl",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v0/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipantNode",
                "kind": "LinkedField",
                "name": "studyParticipants",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudyNode",
                    "kind": "LinkedField",
                    "name": "study",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TagNode",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RespondentNode",
                    "kind": "LinkedField",
                    "name": "respondent",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "masterStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startedOn",
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SelectedResponse",
                "kind": "LinkedField",
                "name": "selectedResponses",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SelectedResponseAnswer",
                    "kind": "LinkedField",
                    "name": "answers",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "row",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rowText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "selected",
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteNode",
                "kind": "LinkedField",
                "name": "tenantNote",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modified",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "modifiedBy",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isStaff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TenantNode",
                    "kind": "LinkedField",
                    "name": "tenant",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enablePanelExport",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicNodeConnection",
                        "kind": "LinkedField",
                        "name": "characteristics",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v19/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TenantGlobalCharacteristicsConnection",
                        "kind": "LinkedField",
                        "name": "globalCharacteristics",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TenantGlobalCharacteristicsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v19/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v20/*: any*/),
                        "concreteType": "PanelistConnection",
                        "kind": "LinkedField",
                        "name": "panelists",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PanelistEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PanelistNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "completedStudiesCount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PersonNode",
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PanelistNode",
                                        "kind": "LinkedField",
                                        "name": "panelist",
                                        "plural": false,
                                        "selections": [
                                          (v0/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v0/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PanelistMembershipNode",
                                    "kind": "LinkedField",
                                    "name": "panelistMembership",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "latestCompleteScreenerName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "latestCompleteScreenerDate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "latestStudyName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "latestStudyDate",
                                        "storageKey": null
                                      },
                                      (v7/*: any*/),
                                      (v0/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CharacteristicResponseNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "responses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CharacteristicResponseNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CharacteristicResponseNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CharacteristicNode",
                                                "kind": "LinkedField",
                                                "name": "characteristic",
                                                "plural": false,
                                                "selections": [
                                                  (v1/*: any*/),
                                                  (v0/*: any*/),
                                                  (v2/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CharacteristicAnswerNode",
                                                "kind": "LinkedField",
                                                "name": "answer",
                                                "plural": false,
                                                "selections": [
                                                  (v0/*: any*/),
                                                  (v16/*: any*/),
                                                  (v17/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CharacteristicRowNode",
                                                "kind": "LinkedField",
                                                "name": "row",
                                                "plural": false,
                                                "selections": (v4/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "textValue",
                                                "storageKey": null
                                              },
                                              (v18/*: any*/),
                                              (v0/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "panelists(first:10)"
                      },
                      {
                        "alias": null,
                        "args": (v20/*: any*/),
                        "filters": [
                          "panelFilters",
                          "searchTerm"
                        ],
                        "handle": "connection",
                        "key": "PanelistsReport_panelists",
                        "kind": "LinkedHandle",
                        "name": "panelists"
                      },
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomPortalNode",
                        "kind": "LinkedField",
                        "name": "customportal",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hidePointsAndRedemption",
                            "storageKey": null
                          },
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PanelNode",
                        "kind": "LinkedField",
                        "name": "panel",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "panelistLayout",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "requireStudyPayment",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "incentivesOrderFulfillmentVerificationDays",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stripePaymentMethodId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stripePaymentMethodLast4",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "caaf8229da8e3d20efdb6913afe892eb",
    "id": null,
    "metadata": {},
    "name": "PanelistsReportWrapperQuery",
    "operationKind": "query",
    "text": "query PanelistsReportWrapperQuery {\n  viewer {\n    ...PanelistsReport_viewer\n    user {\n      profile {\n        tenant {\n          characteristics {\n            edges {\n              node {\n                id\n                importKey\n                text\n                type\n                answers {\n                  id\n                  text\n                }\n              }\n            }\n          }\n          ...PanelistsReport_tenant\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment GivePointsModal_tenant on TenantNode {\n  ...GivePointsPaymentModal_tenant\n}\n\nfragment GivePointsPaymentModal_tenant on TenantNode {\n  requireStudyPayment\n  incentivesOrderFulfillmentVerificationDays\n  stripePaymentMethodId\n  stripePaymentMethodLast4\n}\n\nfragment GivePointsToPanelistModal_panelist on PanelistNode {\n  id\n  person {\n    firstName\n    lastName\n    id\n  }\n}\n\nfragment GivePointsToPanelistModal_tenant on TenantNode {\n  ...GivePointsModal_tenant\n}\n\nfragment Note_panelist on PanelistNode {\n  id\n  tenantNote {\n    id\n    modified\n    modifiedBy {\n      firstName\n      id\n    }\n    text\n  }\n}\n\nfragment PanelistCharacteristics_panelist on PanelistNode {\n  person {\n    email\n    phoneNumber\n    firstName\n    lastName\n    id\n  }\n  id\n  studyParticipants {\n    study {\n      name\n      tags {\n        ...TagTag_tag\n        id\n      }\n      id\n    }\n    respondent {\n      masterStatus\n      startedOn\n      id\n    }\n    id\n  }\n  selectedResponses {\n    key\n    text\n    type\n    answers {\n      key\n      text\n      row\n      rowText\n      selected\n      other\n      userSpecified\n      customAnswer\n    }\n  }\n}\n\nfragment PanelistCharacteristics_tenant on TenantNode {\n  panel {\n    id\n    panelistLayout\n  }\n}\n\nfragment PanelistModal_tenant on TenantNode {\n  customportal {\n    hidePointsAndRedemption\n    id\n  }\n  panel {\n    id\n  }\n  ...GivePointsToPanelistModal_tenant\n  ...PanelistCharacteristics_tenant\n}\n\nfragment PanelistModal_viewer on Viewer {\n  panelist {\n    id\n    dId\n    panelistMembership {\n      latestRatedParticipant {\n        rating\n        id\n      }\n      id\n    }\n    rewardsBalance\n    person {\n      avatarUrl\n      firstName\n      lastName\n      id\n    }\n    joined\n    ...PanelistCharacteristics_panelist\n    ...Note_panelist\n    ...GivePointsToPanelistModal_panelist\n  }\n}\n\nfragment PanelistsReport_tenant on TenantNode {\n  ...PanelistModal_tenant\n}\n\nfragment PanelistsReport_viewer on Viewer {\n  ...PanelistModal_viewer\n  user {\n    isStaff\n    profile {\n      tenant {\n        enablePanelExport\n        characteristics {\n          edges {\n            node {\n              id\n              importKey\n              shortName\n              text\n              type\n              answers {\n                id\n                text\n              }\n              rows {\n                id\n                text\n              }\n            }\n          }\n        }\n        globalCharacteristics {\n          edges {\n            node {\n              id\n              importKey\n              shortName\n              text\n              type\n              answers {\n                id\n                text\n              }\n              rows {\n                id\n                text\n              }\n            }\n          }\n        }\n        panelists(first: 10) {\n          totalCount\n          edges {\n            cursor\n            node {\n              id\n              dId\n              completedStudiesCount\n              person {\n                firstName\n                lastName\n                email\n                phoneNumber\n                panelist {\n                  id\n                }\n                id\n              }\n              panelistMembership {\n                latestCompleteScreenerName\n                latestCompleteScreenerDate\n                latestStudyName\n                latestStudyDate\n                latestRatedParticipant {\n                  rating\n                  id\n                }\n                id\n              }\n              rewardsBalance\n              joined\n              responses {\n                edges {\n                  node {\n                    characteristic {\n                      importKey\n                      id\n                      text\n                    }\n                    answer {\n                      id\n                      other\n                      userSpecified\n                    }\n                    row {\n                      id\n                      text\n                    }\n                    textValue\n                    customAnswer\n                    id\n                  }\n                }\n              }\n              __typename\n            }\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment TagTag_tag on TagNode {\n  color\n  name\n}\n"
  }
};
})();

(node as any).hash = "f4cd4ae2a62e4a7c82f2443210dd27b2";

export default node;
